<template>
	<!-- 전체 타이틀 및 큰이미지들을 표시하고 설명(타이틀) 및 설명 (세부 내용)을 표시하는 컴포넌트 -->
	<div class="multiImageNTextComponent">
		<component :is="title.tag?title.tag:'h4'" v-if="optionGetArray(title.option,'show').value&&title.text" class="componentItemTitle" :class="[title.class]" :style="title.style">{{ title.text }}</component>
		<ul class="imgList" v-if="image.items">
			<li
				v-for="(item, idx) in image.items"
				:key="idx"
				class="componentItemImg"
				:class="[
					'col'+optionGetArray(option,'column').value,
					{'onPadding' : optionGetArray(option, 'onPadding').value},
					{'vAlignCenter' : optionGetArray(image.option, 'align').value==='vcenter'},
					{'hAlignCenter' : optionGetArray(image.option, 'align').value==='hcenter'},
				]"
			>
				<router-link v-if="item.link" :to="item.link">
					<img :src="$store.getters.getUrlPrefix+imgUrlSelect(item.url)" :alt="item.alt">
				</router-link>
				<img v-else :src="$store.getters.getUrlPrefix+imgUrlSelect(item.url)" :alt="item.alt">
			</li>
		</ul>
		<template v-if="optionGetArray(text.option, 'show').value&&text.items">
		<div
			v-for="(textList, tlIdx) in text.items"
			:key="tlIdx"
			class="textItem"
			:class="{'withHyphen' : optionGetArray(text.option, 'hyphen').value}"
		>
			<h4 v-if="textList.title.text" class="textItemTitle" :class="[textList.title.class]" :style="textList.title.style">
				{{ textList.title.text }}
			</h4>
			<span
				class="rowspan"
				v-for="(item, idx) in textList.text"
				:key="idx"
			>{{ item.text }}</span>
		</div>
		</template>
	</div>
</template>

<script>
export default {
	name: 'multiImageNText',
	data () {
		return {}
	},
	props: {
		componentName: {
			type: String,
			default: 'boardItem'
		},
		option: {
			type: Array,
			default: function () {
				return [
					/* {
						name: 'optionName',
						type: 'string, number, boolean, ',
						value: value
					} */
				]
			}
		},
		title: {
			type: Object,
			default: function () {
				return {
					uiType: 'input',
					text: '',
					option: [
						/* {
							name: 'optionName',
							type: 'string, number, boolean, ',
							value: value
						} */
					],
					class: '', /* 'className1 className2', ... */
					style: {
						/* color: '#32320a', fontSize: '24px', padding: '20px 10px 20px 5px', margint: '0px auto 20px auto' */
					}
				}
			}
		},
		image: {
			type: Object,
			default: function () {
				return {
					uiType: 'files',
					option: [
						{
							name: 'onPadding',
							type: 'boolean',
							value: true
						}
					],
					items: [
						{
							url: '',
							alt: '',
							link: '',
							target: ''
						}
					]
				}
			}
		},
		text: {
			type: Object,
			default: function () {
				return {
					uiType: 'input',
					option: [
						{
							name: 'show',
							type: 'boolean',
							value: true
						},
						{
							name: 'hyphen',
							type: 'boolean',
							value: false
						}
					],
					items: [
						{
							title: {
								uiType: 'input',
								text: '',
								class: '', /* 'className1 className2', ... */
								style: {
									/* color: '#32320a', fontSize: '24px', padding: '20px 10px 20px 5px', margint: '0px auto 20px auto' */
								}
							},
							text: [
								{
									uiType: 'input',
									text: '',
									class: '', /* 'className1 className2', ... */
									style: {
										/* color: '#32320a', fontSize: '24px', padding: '20px 10px 20px 5px', margint: '0px auto 20px auto' */
									}
								}
							],
							link: '',
							target: ''
						}
					]
				}
			}
		}
	},
	methods: {
		imgUrlSelect (item) {
			var itemType = typeof (item)
			var urlObj
			var url
			if (itemType === 'string') {
				urlObj = { pc: item, tablet: item, mobile: item }
			} else if (itemType === 'object') {
				urlObj = item
			}
			if (this.$store.state.device === 'pc') {
				url = urlObj.pc ? urlObj.pc : ''
			} else if (this.$store.state.device === 'tablet') {
				url = urlObj.tablet ? urlObj.tablet : urlObj.pc
			} else if (this.$store.state.device === 'mobile') {
				url = urlObj.mobile ? urlObj.mobile : urlObj.pc
			}
			return url
		},
		optionGetArray (obj, name) {
			var tgArray = []
			for (var arrItem in obj) {
				tgArray.push(obj[arrItem])
			}
			var idx = tgArray.findIndex(function (opt) {
				return opt.name === name
			})
			var result = obj[idx]
			return result
		}
	}
}
</script>

<style lang="scss"> // scoped
@import '@/css/variables.scss';
.multiImageNTextComponent {
	margin-bottom: 80px;
	.imgList {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		.componentItemImg {
			width: 100%;
			position: relative;
			margin-bottom: 20px;
			img {
				display: block;
				width: 100%;
			}
			&.vAlignCenter {
				height: 400px;
				width: 100%;
				background-color: $c-gray-bright;
				overflow: hidden;
				img {
					position: absolute;
					width: 100% !important; height: auto !important; min-height: auto;
					top: 50%; left: 50%;
					transform: translate(-50%, -50%);
				}
			}
			&.hAlignCenter {
				height: 400px;
				width: 100%;
				background-color: $c-gray-bright;
				overflow: hidden;
				img {
					position: absolute;
					width: auto !important; height: 100% !important; min-width: auto; max-width: none;
					top: 50%; left: 50%;
					transform: translate(-50%, -50%);
				}
			}
			&.col2,
			&.col4 {
				width: 49%;
				img {
					height: auto;
				}
			}
			&.col3 {
				width: 32%;
			}
			&.col4 {
				margin-bottom: 24px;
				&:nth-last-child(1),
				&:nth-last-child(2) {
					margin-bottom: 0;
				}
			}
			&.onPadding {
				padding: 0 14%;
			}
		}
		& + .textItem {
			margin-top: 50px;
		}
	}
	.componentItemTitle {
		display: block;
		margin-bottom: 24px;
		font-size: $text-medium;
		font-weight: bold;
	}
	.textItem {
		margin-bottom: 20px;
		&:last-child {
			margin-bottom: 0;
		}
		.textItemTitle {
			display: block;
			letter-spacing: $lspace-short;
			font-size: $title-tiny;
			& + .rowspan {
				margin-top: 16px;
			}
		}
		.rowspan {
			display: block;
			color: $c-gray-dark;
		}
		&.withHyphen {
			.rowspan {
				position: relative;
				padding-left: 10px;
				&::before {
					display: block;
					position: absolute;
					left: 0;
					content: '-';
				}
			}
		}
	}
}

/*
	##Device = Laptops, Desktops
	##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  //CSS
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 650px) and (max-width: 767px) {
	//css
}

// 미세조정
@media (min-width: 481px) and (max-width: 649px) {
	.multiImageNTextComponent {
		.imgList {
			$multiple: 2.04;
			$w: 100%;
			.componentItemImg {
				display: inline-block;
				width: $w;
				img {
					width: $w;
				}

				&.col2,
				&.col3,
				&.col4 {
					width: $w/$multiple;
				}
				&.col3 {
					&:nth-child(3) {
						width: $w;
						margin-top: 12px;
					}
				}
				&.col4 {
					&:nth-last-child(1),
					&:nth-last-child(2) {
						margin-top: 12px;
					}
				}
				&.onPadding {
					padding: 0;
				}
			}
			& + .textItem {
				margin-top: 15px;
			}
		}
		.componentItemTitle {
			margin-bottom: 12px;
			font-size: $title-xsmall;
		}
		.textItem {
			.textItemTitle {
				font-size: $title-xtiny;
				& + .rowspan {
					margin-top: 8px;
				}
			}
			.rowspan {
				font-size: $text-tiny;

				&+.rowspan {
					padding-top: 2px;
				}
			}
		}
	}
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
	.multiImageNTextComponent {
		.imgList {
			$w: 100%;
			// display: block;
			// flex-wrap: unset;
			// justify-content: unset;
			.componentItemImg {
				width: $w;
				img {
					width: $w;
				}

				&.col2,
				&.col3,
				&.col4 {
					width: $w;
					margin-top: 12px;
					&:first-child {
						margin-top: 0;
					}
				}
				&.col4 {
					margin-bottom: 0;
					&:nth-last-child(1),
					&:nth-last-child(2) {
						margin-bottom: 0;
					}
				}
				&.onPadding {
					padding: 0;
				}
			}
			& + .textItem {
				margin-top: 15px;
			}
		}
		.componentItemTitle {
			margin-bottom: 12px;
			font-size: $title-xsmall;
		}
		.textItem {
			.textItemTitle {
				font-size: $title-xtiny;
				& + .rowspan {
					margin-top: 8px;
				}
			}
			.rowspan {
				font-size: $text-tiny;

				&+.rowspan {
					padding-top: 2px;
				}
			}
		}
	}
}
</style>
